

















































































































































































































































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Coupon, Lottery, LotteryCouponSetting } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef, Loading } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";
import { generateDocumentId } from "@/common/generateDocumentId";
import firebaseConfig from "@/config/firebaseConfig.json";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "ShopLotteryLotteryDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    imageEditor: boolean;
    uploadingFile: boolean;
    replaceIndex: number;
    loading: Loading;
    csvName: string;
    editedImage: string[];
    html: string;
    conditions_html: string;
    codeCsvStatus: number;
    codeList: { id: number; code: string }[];
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      imageEditor: false,
      uploadingFile: false,
      replaceIndex: -1,
      loading: new Loading(),
      csvName: "",
      editedImage: [],
      html: "",
      conditions_html: "",
      codeCsvStatus: 0,
      codeList: []
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
      if (_doc) {
        this.html = _doc.data()?.content || "";
        this.conditions_html = _doc.data()?.conditions || "";
      }
    } else {
      this.document.effective.lotteryCoupons = [];
    }
    if (!this.document.effective.pushSend) {
      this.document.effective.pushSend = false;
    }
    this.codeCsvStatus = this.document.effective.codeCsvStatus
      ? this.document.effective.codeCsvStatus
      : 0;
    if (!this.document.effective.sameCodeCanUsed) {
      this.document.effective.sameCodeCanUsed = false;
    }
    const inputList = this.codeList;
    if (this.document.effective.lotteryCode1) {
      inputList.push({
        id: 0,
        code: this.document.effective.lotteryCode1
      });
    }
    if (this.document.effective.lotteryCode2) {
      inputList.push({
        id: 0,
        code: this.document.effective.lotteryCode2
      });
    }
    if (this.document.effective.lotteryCode3) {
      inputList.push({
        id: 0,
        code: this.document.effective.lotteryCode3
      });
    }
    if (this.document.effective.lotteryCode4) {
      inputList.push({
        id: 0,
        code: this.document.effective.lotteryCode4
      });
    }
    if (this.document.effective.lotteryCode5) {
      inputList.push({
        id: 0,
        code: this.document.effective.lotteryCode5
      });
    }
    this.codeList = this.makeNewInput(inputList);
  },
  computed: {
    collection(): Collection<Lottery> {
      const path = `/lottery`;
      return new Collection(
        db.collection(path) as firestore.CollectionReference<Lottery>
      );
    },
    document(): Document<Lottery> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id ? "抽選会詳細" : "抽選会新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規抽選会";
    },
    saveButtonName(): string {
      return this.document?.data?.publishStatus != 2 ? "下書き保存" : "保存";
    },
    coupons(): List<Coupon> {
      return new Collection<Coupon>(
        db.collection("coupon") as firestore.CollectionReference<Coupon>
      ).query({
        filter: {
          shopId: { $eq: this.shopId },
          isLotteryCoupon: { $eq: 1 },
          publishStatus: { $eq: 2 }
        },
        orderBy: {
          field: "createTime",
          order: "desc"
        }
      });
    }
  },
  methods: {
    getCouponImageUrl(couponId: string) {
      if (couponId) {
        const coupon = this.coupons.items?.find(item => item.id == couponId);
        if (coupon) {
          return coupon.data?.image ? this.imageUrl(coupon.data?.image[0]) : "";
        }
      }
      return "";
    },
    getCouponTitle(couponId: string) {
      if (couponId) {
        const coupon = this.coupons.items?.find(item => item.id == couponId);
        if (coupon) {
          return coupon.data?.title;
        }
      }
      return "";
    },
    getCouponAvailable(couponId: string) {
      if (couponId) {
        const coupon = this.coupons.items?.find(item => item.id == couponId);
        if (coupon) {
          if (coupon.data?.unlimited) {
            return "無期限";
          } else {
            let date = "";
            if (coupon.data?.availableFrom) {
              date += this.formatFullDate(coupon.data?.availableFrom);
            }
            date += "〜";
            if (coupon.data?.availableTo) {
              date += this.formatFullDate(coupon.data?.availableTo);
            }
            return date;
          }
        }
      }
      return "";
    },
    addCoupon() {
      const newCoupon = this.lotteryCouponSettingFactory();
      this.document?.effective.lotteryCoupons?.push(newCoupon);
    },
    deleteCoupon(index: number) {
      this.document.effective.lotteryCoupons?.splice(index, 1);
      this.lotteryCouponsUpdate();
    },
    lotteryCouponSettingFactory() {
      return {
        lotteryCouponSettingId: generateDocumentId(),
        lotteryCouponId: "",
        winnersUnlimited: false,
        winnersNumber: "",
        winningRate: ""
      } as LotteryCouponSetting;
    },
    lotteryCouponsUpdate() {
      const lotteryCoupons = this.document.effective.lotteryCoupons;
      if (lotteryCoupons) {
        this.document.effective.lotteryCoupons = [...lotteryCoupons];
      }
    },
    setNow() {
      this.document.effective.discloseAt = this.formatFullDate(this.now);
      this.justifyNow = true;
    },
    async register() {
      if (
        this.document.effective.pushSend &&
        !this.document.effective.pushStatus
      ) {
        if (dayjs(this.document.effective.pushAt).valueOf() < Date.now()) {
          await alert({
            title: "エラー",
            text: "プッシュ配信を行う場合、配信日時は未来を設定してください。"
          });
          return;
        }
      }
      if (this.document.effective.content != this.html) {
        this.document.effective.content = this.html;
      }
      if (this.document.effective.conditions != this.conditions_html) {
        this.document.effective.conditions = this.conditions_html;
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return;
      }
      if (
        !this.document.effective.image ||
        this.document.effective.image.length != 1
      ) {
        alert({
          title: "エラー",
          text: "画像の登録は必須です。"
        });
        return;
      }

      const lotteryCoupons = this.document.effective.lotteryCoupons;
      const lotteryCouponIds: string[] = [];
      let totalRate = 0;
      let totalNumber = 0;
      if (this.document.effective.losingSetting) {
        totalRate += Number(this.document.effective.losingRate);
        totalRate = Math.round(totalRate * 100) / 100; // 結果を2桁まで丸める
      }
      if (lotteryCoupons) {
        for (let i = 0; i < lotteryCoupons.length; i++) {
          const lotteryCoupon = lotteryCoupons[i];
          if (
            !lotteryCoupon.lotteryCouponId ||
            !lotteryCoupon.winnersNumber ||
            !lotteryCoupon.winningRate
          ) {
            alert({
              title: "エラー",
              text:
                "クーポン、当選者上限、当選確率が設定されていない景品クーポンがあります。"
            });
            return;
          }
          if (lotteryCouponIds.indexOf(lotteryCoupon.lotteryCouponId) != -1) {
            alert({
              title: "エラー",
              text: "景品クーポンに同じクーポンが設定されています。"
            });
            return;
          }
          lotteryCouponIds.push(lotteryCoupon.lotteryCouponId);
          if (lotteryCoupon.winningRate) {
            totalRate += Number(lotteryCoupon.winningRate);
            totalRate = Math.round(totalRate * 100) / 100; // 結果を2桁まで丸める
          }
          if (lotteryCoupon.winnersNumber) {
            totalNumber += Number(lotteryCoupon.winnersNumber);
          }
        }
      }
      if (totalRate != 100) {
        alert({
          title: "エラー",
          text: "当選確率は合計で100.0になるように設定してください。"
        });
        return;
      }
      const entrysLimitNumber = this.document.effective.entrysLimitNumber
        ? Number(this.document.effective.entrysLimitNumber)
        : 0;
      if (this.document.effective.losingSetting) {
        // はずれ設定あり
        if (totalNumber >= entrysLimitNumber) {
          alert({
            title: "エラー",
            text:
              "はずれを設定する場合、当選者上限の合計は抽選回数上限より少なく設定してください。"
          });
          return;
        }
      } else {
        // はずれ設定なし
        if (totalNumber != entrysLimitNumber) {
          alert({
            title: "エラー",
            text:
              "はずれを設定しない場合、当選者上限の合計は抽選回数上限と同じになるように設定してください。"
          });
          return;
        }
      }

      if (this.document.effective.codeType == 2) {
        // 複数コード指定
        const check: { [key: string]: string } = {};
        let codeLen = 0;
        for (const code of this.codeList) {
          if (code.code != "") {
            if (check[code.code]) {
              alert({
                title: "エラー",
                text: "同じ抽選コードを複数指定できません。"
              });
              return;
            }
            check[code.code] = code.code;
            codeLen++;
          }
        }

        if (this.document.effective.csvCapture) {
          // CSV取込あり
          if (codeLen > 0) {
            alert({
              title: "エラー",
              text:
                "CSVでの取込が行われているため抽選コード入力による指定はできません。"
            });
            return;
          }
          if (
            this.document.effective.codeCsvStatus == 4 &&
            !this.document.effective.sameCodeCanUsed
          ) {
            // 同一での抽選コードを用いた抽選を不可能
            if (this.document.effective.codeCsvCount != entrysLimitNumber) {
              alert({
                title: "エラー",
                text:
                  "同一での抽選コードを用いた抽選を不可能と設定した場合、抽選回数上限は抽選コードの数と同じになるように設定してください。"
              });
              return;
            }
          }
        } else {
          // CSV取込なし
          if (!this.document.effective.sameCodeCanUsed) {
            // 同一での抽選コードを用いた抽選を不可能
            if (codeLen != entrysLimitNumber) {
              alert({
                title: "エラー",
                text:
                  "同一での抽選コードを用いた抽選を不可能と設定した場合、抽選回数上限は抽選コードの数と同じになるように設定してください。"
              });
              return;
            }
          }
        }

        this.document.effective.lotteryCode1 = "";
        this.document.effective.lotteryCode2 = "";
        this.document.effective.lotteryCode3 = "";
        this.document.effective.lotteryCode4 = "";
        this.document.effective.lotteryCode5 = "";
        for (const code of this.codeList) {
          if (code.id == 0) {
            this.document.effective.lotteryCode1 = code.code;
          } else if (code.id == 1) {
            this.document.effective.lotteryCode2 = code.code;
          } else if (code.id == 2) {
            this.document.effective.lotteryCode3 = code.code;
          } else if (code.id == 3) {
            this.document.effective.lotteryCode4 = code.code;
          } else if (code.id == 4) {
            this.document.effective.lotteryCode5 = code.code;
          }
        }
      }

      this.loading.run(async () => {
        if (this.document.effective.codeCsvStatus == 1) {
          // 抽選コードCSVのアップがあり、同一抽選コードによる抽選を利用不可の場合
          // 抽選コードCSVのバリデーション
          const functions = firebaseProject.functions("asia-northeast1");
          const callable = functions.httpsCallable(
            "consoleLotteryValidateCodeCsv"
          );
          const params = {
            shopId: this.shopId,
            filePath: this.document.effective.codeCsvPath,
            entrysLimitNumber: this.document.effective.entrysLimitNumber,
            sameCodeCanUsed: this.document.effective.sameCodeCanUsed
          };

          const validate = await callable(params)
            .then(res => {
              console.log(res);
              return true;
            })
            .catch(e => {
              console.error(e);
              alert({
                title: "エラー",
                text: e.message
              });
              return false;
            });
          if (!validate) {
            return;
          }
        }

        if (lotteryCoupons) {
          this.document.effective.lotteryCoupons = [...lotteryCoupons];
        }

        if (this.document.canSave) {
          this.document.effective.shopId = this.shopId;
          const result = await this.document.save().catch(e => {
            alert({
              title: "エラー",
              text: "抽選会の保存に失敗しました。"
            });
          });
          if (result) {
            this.$router.push("/shoplottery/lottery");
          }
        } else {
          this.$router.push("/shoplottery/lottery");
        }
      });
    },
    async registerAndPublish() {
      if (!this.document.effective.discloseAt) {
        alert({
          title: "エラー",
          text: "配信開始日時が設定されていません。"
        });
      } else {
        this.document.effective.publishStatus = 2;
        if (!this.document.effective.pushStatus) {
          this.document.effective.pushStatus = 0;
        }
        await this.register();
      }
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/shoplottery/lottery");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    selectImage() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteImage(index: number) {
      if (this.document?.effective.image) {
        this.document.effective.image.splice(index, 1);
        this.document.effective.image = [...this.document.effective.image];
      }
    },
    openImageEditor() {
      const images = this.document?.effective.image || [];
      this.editedImage = [...images];
      this.imageEditor = true;
    },
    closeImageEditor(save: boolean) {
      if (this.uploadingFile) {
        return;
      }
      if (save) {
        this.document.effective.image = [...this.editedImage];
      }
      this.replaceIndex = -1;
      this.imageEditor = false;
    },
    selectEditImage(index: number) {
      this.replaceIndex = index;
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteEditImage(index: number) {
      this.editedImage.splice(index, 1);
    },
    async uploadFile(event: Event) {
      this.uploadingFile = true;
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
          this.uploadingFile = false;
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".jpg";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/jpeg";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(downloadURL => {
                    if (this.document.effective.image == undefined) {
                      this.document.effective.image = [];
                    }
                    const url = _path;
                    if (this.replaceIndex > -1) {
                      this.editedImage.splice(this.replaceIndex, 1, url);
                    } else {
                      const newArr = this.document.effective.image.slice(
                        0,
                        this.document.effective.image.length
                      );
                      newArr.push(url);
                      this.document.effective.image = newArr;
                    }
                    this.uploadingFile = false;
                  })
                  .catch(error => {
                    console.log(error);
                    this.uploadingFile = false;
                  });
              },
              {
                maxWidth: 1200,
                maxHeight: 1200,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    },
    selectCsv() {
      (this.$refs.csvfileupload as HTMLInputElement).click();
    },
    async uploadCsvFile(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択してください。"
          });
          event.target.value = "";
        } else {
          event.target.files.forEach((item: File) => {
            this.loading.run(async () => {
              const _path = "lottery/code/temp/" + Uuidv4() + ".csv";
              const ref = firebaseProject
                .storage(`gs://${firebaseConfig.projectId}-data-storage`)
                .ref()
                .child(_path);
              await ref
                .put(item)
                .then(snapshot => {
                  return snapshot.ref.getDownloadURL();
                })
                .then(downloadURL => {
                  console.log(downloadURL);
                  this.csvName = item.name;
                  this.document.effective.codeCsvPath = _path;
                  this.document.effective.codeCsvStatus = 1; // 取り込み待ち
                })
                .catch(error => {
                  console.log(error);
                });
            });
          });
          event.target.value = "";
        }
      }
    },
    //codeCsvStatus	1=登録処理待ち、2=登録処理中（CSVファイルチェック）、3=登録処理中、4=登録処理済、9=取り込みエラー
    checkCsvStauts() {
      return (
        this.codeCsvStatus == 4 ||
        this.codeCsvStatus == 9 ||
        this.codeCsvStatus == 0
      );
    },
    changeLotteryCodeType(event: any, codeType: number) {
      if (event.target.checked) {
        this.document.effective.codeType = codeType;
      } else {
        this.document.effective.codeType = 0;
      }
    },
    addInput() {
      if (this.codeList.length > 4) return;
      const inputList = this.codeList;
      inputList.push({
        id: 0,
        code: ""
      });
      this.codeList = this.makeNewInput(inputList);
    },
    removeInput(id: number) {
      let inputList = this.codeList;
      inputList = inputList.filter((input: any) => input.id !== id);
      this.codeList = this.makeNewInput(inputList);
    },
    makeNewInput(inputList: any) {
      const newInputList = [];
      let i = 0;
      for (const input of inputList) {
        newInputList.push({
          id: i,
          code: input.code
        });
        i++;
      }
      return newInputList;
    }
  }
});
